import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import {  useParams } from "react-router-dom";
import SingleItem from "./SingleItem";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import CustomPagination from "../../../../../CustomPagination/CustomPagination";

const OrderSetAssignedView = ({ result }) => {

    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [paginateData, setPaginateData] = useState([]);
    const [data, setData] = useState([]);
    const [upadateData, setUpdateData] = useState([]);

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/order-set/assign/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
                setPaginateData(data);
                setLoading(false);
            });
    }, [result, upadateData]);

    const handlePage = (event) => {
        try {
            const pageNumber = event?.selected + 1;
            const config = {
                headers: {
                    "content-type": "application/json",
                },
            };
            axios
                .get(
                    `https://api.velormall.com/api/admin/order-set/assign/view/${id}?page=${pageNumber}`,
                    config
                )
                .then((response) => {
                    setData(response?.data?.data);
                    setPaginateData(response?.data);
                })
                .catch((error) => { });
        } catch (error) {
            console.log(error);
        }
    };


    const handleDelete = (id) => {
        fetch(`https://api.velormall.com/api/admin/order-set/assign/delete/${id}`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setUpdateData(data?.data)
                toast.error(`${data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .catch((error) => console.log(error));
    };


    if (loading) {
        return (
            <>
                <div className="loader-css">
                    <RotatingSquare
                        visible={true}
                        height="100"
                        width="100"
                        color="#4fa94d"
                        ariaLabel="rotating-square-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            </>
        );
    }
    return (
        <>

            <div className="card mt-30 ">
                <div className="card-header">
                    <h5 className="card-title mb-0">
                        Order Set Assigned
                    </h5>
                </div>
                <div className="p-2">
                    <div className="card b-radius--10 ">
                        <div className="card-body p-0">
                            <div className="table-responsive--md  table-responsive">
                                <table className="table table--light style-two mb-0">
                                    <thead>
                                        <tr>
                                            <th>Order Set</th>
                                            <th>Completed</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length !== 0 ? (
                                            data.map((data, index) => {
                                                if (data) {
                                                    return (
                                                        <SingleItem
                                                            data={data}
                                                            index={index}
                                                            key={data._id}
                                                            handleDelete={handleDelete}
                                                            paginateData={paginateData}
                                                        ></SingleItem>
                                                    );
                                                }
                                            })
                                        ) : (
                                            <tr>
                                                <td className="text-muted text-center" colspan="100%">
                                                    Data not found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* paginateLinks */}
                        <CustomPagination
                            data={paginateData}
                            handlePage={handlePage}
                        ></CustomPagination>
                        {/* paginateLinks */}
                    </div>
                </div>
            </div>

        </>
    );


};

export default OrderSetAssignedView;
